import log from '~/utils/log';

/** Short enough that a hung request cannot hold up the refresh waiting behind it. */
const INVALIDATE_CACHE_TIMEOUT = 10_000;

/**
 * Marks the cached Docebo response for one course stale, so the next read of it fetches again.
 * Makes no Docebo call itself.
 */
export const invalidateAcademyCourseCache = async (courseId: string | number): Promise<void> => {
    try {
        await $fetch(`/api/academy/docebo/${encodeURIComponent(String(courseId))}/invalidate-cache`, {
            credentials: 'include',
            timeout: INVALIDATE_CACHE_TIMEOUT
        });
    } catch (error) {
        log.warn('[academy] failed to invalidate the cached course', { courseId, error });
    }
};
